<template>
  <div id="userEditWrapper">
    <div v-if="success" class="notification is-success">
      <button class="delete" @click="toggleSuccess"></button>
      <strong>Succes!</strong> De gebruiker is opgeslagen. Als dit een nieuwe gebruiker is, is er een e-mail gestuurd naar {{ user.email }} met een wachtwoord en activatie instructies.
    </div>

    <div class="field">
      <label class="label" for="firstname">Voornaam/-letters</label>
      <div class="control">
        <input type="text" class="input" v-model="params.firstname">
      </div>
    </div>

    <div class="field">
      <label class="label" for="lastname">Achternaam</label>
      <div class="control">
        <input type="text" class="input" v-model="params.lastname">
      </div>
    </div>

    <div class="field">
      <label class="label" for="email">E-mail</label>
      <div class="control">
        <input type="text" class="input" v-model="params.email">
      </div>
    </div>

    <div class="tabs">
      <ul>
        <li :class="{ 'is-active': visibleTab === 1 }"><a @click="toggle(1)">Rechten</a></li>
        <li :class="{ 'is-active': visibleTab === 2 }"><a @click="toggle(2)">Bundels</a></li>
        <li :class="{ 'is-active': visibleTab === 3 }"><a @click="toggle(3)">Account Items</a></li>
      </ul>
    </div>

    <scopes
      v-if="visibleTab === 1"
      :user="user"
      :myScopes="params.scopes">
    </scopes>

    <bundles
      v-if="visibleTab === 2"
      :userId="user.id"
      :myBundles="user.bundles">
    </bundles>

    <items
      v-if="visibleTab === 3"
      :userId="user.id"
      :myItems="user.items">
    </items>

    <save-buttons
      :disabled="!valid"
      @save="save"
      @cancel="cancel">
    </save-buttons>
  </div>
</template>

<script>
import { bus } from '@/main'
import { mapGetters } from 'vuex'
import Scopes from '@/components/scopes/Scopes'
import Items from '@/components/items/UserItems'
import Bundles from '@/components/bundles/UserBundles'
import SaveButtons from '@/components/modules/SaveButtons'

export default {
  props: [
    'user',
    'isActive'
  ],
  components: {
    Items,
    Scopes,
    Bundles,
    SaveButtons
  },
  data () {
    return {
      params: {},
      success: false,
      visibleTab: 1
    }
  },
  computed: {
    ...mapGetters({
      scopes: 'scopes/scopes'
    }),
    valid () {
      return this.params.firstname !== '' &&
        this.params.lastname !== '' &&
        this.params.email !== ''
    }
  },
  created () {
    this.params = this.duplicate(this.user)

    bus.$on('scope.value.changed', (payload) => {
      this.setScope(payload)
    })
  },
  methods: {
    toggleSuccess () {
      this.success = !this.success
    },
    save () {
      this.$emit('save', this.params)

      this.close()
    },
    cancel () {
      this.$store.commit('users/RESET')
      this.close()
    },
    close () {
      this.$emit('close')
    },
    toggle (idx) {
      this.visibleTab = idx
    },
    duplicate (obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    setScope (payload) {
      (payload.selected) ? this.params.scopes.push(payload.id) : this.params.scopes.splice(this.params.scopes.findIndex(scope => scope === payload.id), 1)
    }
  }
}
</script>

<style scoped>
  .message a:not(.button):not(.tag) {
    text-decoration: none;
  }
</style>
